"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".rootIsFixed_9953dd44{position:fixed;z-index:1000000;top:0;left:0;width:100vw;height:100vh;visibility:hidden}.content_9953dd44{visibility:visible}\n" }]);
exports.rootIsFixed = "rootIsFixed_9953dd44";
exports.content = "content_9953dd44";
//# sourceMappingURL=Layer.scss.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/components/Layer/Layer.scss.js
// module id = ../node_modules/office-ui-fabric-react/lib/components/Layer/Layer.scss.js
// module chunks = 1